<template>
  <DeviceVerificationModal
    :visible="deviceStore.showVerificationModal"
    @close="deviceStore.closeModal"
  />
  <!-- Main Content -->
  <div class="main-container" :class="{ 'nav-open': isSidebarOpen }">
    <!-- Left Side Content (Categories and Food Items) -->
    <div class="left-side-container">
      <!-- Header -->
      <AppHeader
        :foodSearchEnabled="true"
        :search-query="searchQuery"
        @update:search="searchQuery = $event"
        @open-current-order-cart="toggleCurrentOrderCart(true)"
      />

      <div class="left-side-content-container">
        <!-- Sidebar -->
        <AppSidebar :is-open="isSidebarOpen" />
        <div class="left-side-main-content">
          <!-- CategoriesTab -->
          <CategoriesTab v-model:category="selectedCategory" />
          <h2 class="active-menu-title">{{ selectedCategory }}</h2>
          <!-- FoodItemsGrid -->
          <FoodItemsGrid
            :category="selectedCategory"
            :search-query="searchQuery"
            @open-food-modal="openFoodModal"
          />
        </div>
      </div>
    </div>

    <!-- Right Side Content (Current Order) -->
    <div class="right-side-container" :class="{ 'cart-open': isCartOpen }">
      <div class="right-side-content">
        <!-- CurrentOrderPanel -->
        <CurrentOrderPanel @close-cart="toggleCurrentOrderCart(false)" />
      </div>
    </div>

    <!-- Modals -->
    <FoodModal
      :is-open="isFoodModalOpen"
      :food-item="selectedFoodItem"
      @update:isOpen="isFoodModalOpen = $event"
    />
  </div>
  <div class="footer-content">
    <SoftwareInfo />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useDeviceVerifierStore } from "@/stores/deviceVerifier";
import { useSystemSettingsStore } from "@/stores/systemSettings";
import AppHeader from "@/components/base/appHeader.vue";
import AppSidebar from "@/components/base/appSidebar.vue";
import CategoriesTab from "@/components/order/categoriesTab.vue";
import FoodItemsGrid from "@/components/order/foodItemsGrid.vue";
import CurrentOrderPanel from "@/components/order/currentOrderPanel.vue";
import FoodModal from "@/components/order/modals/foodModal.vue";
import DeviceVerificationModal from "@/components/order/modals/deviceVerificationModal.vue";
import SoftwareInfo from "@/components/base/softwareInfo.vue";

const deviceStore = useDeviceVerifierStore();
const { getSidebarState } = useSystemSettingsStore();

const isFoodModalOpen = ref(false);

const isCartOpen = ref(false);
const isSidebarOpen = computed(() => getSidebarState());

const searchQuery = ref("");
const selectedCategory = ref("");
const selectedFoodItem = ref(null);

const openFoodModal = (item) => {
  selectedFoodItem.value = item;
  isFoodModalOpen.value = true;
};

const toggleCurrentOrderCart = (value) => {
  isCartOpen.value = value;
};
</script>
